module.exports = __webpack_public_path__ + "static/media/74.86010fa3.jpg";